import React, { FC } from 'react';
import { Badge } from '@firesoon/antd';
import { BadgeProps } from '@firesoon/antd/lib/badge/index';
import './index.less';

const Index: FC<BadgeProps> = ({ children, className = '', ...rest }) => {
  return (
    <Badge className={`fs-badge ${className}`} {...rest}>
      {children}
    </Badge>
  );
};

export default Index;
